import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetTagContasReceberResponse, CreateTagContasReceberResponse } from '../../responses/financas/tag-contas-receber.response';
import { TagFinanceiraRequest } from '../../requests/financas/tag-financeira.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root',
})
export class TagContasReceberService extends CommonService {
    private readonly apiUrl: string = environment.urlApiFinancas + 'TagContasReceber';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getAll(descricao: string = '', pagina: number = 1, tamanhoPagina: number = 20): Observable<GetTagContasReceberResponse> {
        let params = new HttpParams()
            .set('pagina', pagina.toString())
            .set('tamanhoPagina', tamanhoPagina.toString());

        if (descricao) {
            params = params.set('descricao', descricao);
        }

        return this.httpClient
            .get<GetTagContasReceberResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    public getById(id: number): Observable<CreateTagContasReceberResponse> {
        const url = `${this.apiUrl}/idTagContasReceber/${id}`;
        return this.httpClient
            .get<CreateTagContasReceberResponse>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public create(request: TagFinanceiraRequest): Observable<CreateTagContasReceberResponse> {
        return this.httpClient
            .post<CreateTagContasReceberResponse>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public update(id: number, request: TagFinanceiraRequest): Observable<CreateTagContasReceberResponse> {
        const url = `${this.apiUrl}/idTagContasReceber/${id}`;
        return this.httpClient
            .put<CreateTagContasReceberResponse>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public delete(id: number): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/idTagContasReceber/${id}`;
        return this.httpClient
            .delete<ReturnStruct>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public deleteBulk(ids: number[]): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/bulk-delete`;
        return this.httpClient
            .post<ReturnStruct>(url, { ids }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
